module.exports = __webpack_public_path__ + "static/media/signup_bg.79ff44e1.png";